import { Auth } from "aws-amplify";
import { FINTELLIGENCE_PERISCOPE } from "../constants/api_constants";

const amplifyConfig = {
    Auth: {
        mandatorySignIn: true,
        region: process.env.REACT_APP_COGNITO_REGION,
        userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
        userPoolWebClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
        identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
    },
    API: {
        endpoints: [
            {
                name: FINTELLIGENCE_PERISCOPE,
                endpoint: process.env.REACT_APP_API_GATEWAY_ENDPOINT,
                region: process.env.REACT_APP_API_GATEWAY_REGION,
                custom_header: async () => ({
                    Authorization: (await Auth.currentSession()).getIdToken().getJwtToken(),
                }),
            },
        ],
    },
    Storage: {
        bucket: process.env.REACT_APP_S3_UPLOAD_BUCKET,
        region: process.env.REACT_APP_COGNITO_REGION,
        customPrefix: { public: "" },
    },
};

export default amplifyConfig;
